import useToggle from "@/hooks/useToggle";
import { Dialog } from "../Dialog";

export const ExternalLink = ({ uri }: { uri: string }) => {
  const { show: showModal, toggle: toggleModal } = useToggle();

  return (
    <>
      <div>
        <div onClick={toggleModal}>
          <span className="text-[#acacac] font-bold underline italic cursor-pointer">
            {uri}
          </span>
        </div>
      </div>
      {showModal && (
        <Dialog isOpen={showModal} onClose={toggleModal}>
          <iframe
            width="560"
            height="315"
            src={uri}
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </Dialog>
      )}
    </>
  );
};
